export default {
  geolocation: {
    lat: '52.5200',
    lng: '13.4050',
    label: '10115 Berlin',
  },
  price_rules: {
    grouping: '.',
    decimal: ',',
  },
}
